// extracted by mini-css-extract-plugin
export default {"container":"specialty-selection-page_container__6rfMm","bottombar":"specialty-selection-page_bottombar__tYWzr"};